export const slugify = (outerText: string) =>
  outerText
    .toLowerCase()
    .trim()
    .replaceAll(/[\s!,:;?@BDOY]+/g, '-')
    .replaceAll(/-+/g, '-')
    .replaceAll(/^-|-$/g, '');
